export enum ConfigurationSettingItemType {
  TEXT = 'TEXT',
  LINK = 'LINK',
  TOGGLE = 'TOGGLE',
  DATE = 'DATE',
}
